module.exports = __webpack_public_path__ + "img/club-brugge-logo-icon.68150261.png";